//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tree from "./public/tree.vue";
export default {
  name: "zaixianyuyue",
  components: {
    tree,
  },
  data() {
    return {
      loading: false,
      popup: false,
      popup_left: false,
      popup_right: false,
      page: 1,
      last_page: 0,
      quantity: 10,
      total: "",
      checkbox: [],
      title_name: "点击选择门店",
      popup_content: [],
      popup_id: "",
      tree_data: [],
      content: [],
      scroller: [],
      yuyue: [],
      yuyuedingdan: [],
      showPrice: "",
      itemImg: require('../../src/assets/gouxuan.png'),
      Active:null,
      search:'',
    };
  },
  methods: {
    onClickTitle: function () {
      this.popup = true;
    },
    // 搜索
    query(){
      //收起键盘
      if(this.search.trim()){
        this.$HTTP
        .HttpPost("/Member/Appointment/getItemList", {
          sid: this.popup_id,
          page: 1,
          quantity: this.quantity,
          search:this.search
        })
        .then((data) => {
          console.log(data.data.data.data);
          this.last_page = data.data.data.last_page;
          this.content = data.data.data.data;
          this.scroller = [...this.content];
          this.showPrice = this.scroller[0] && this.scroller[0].price;
          this.total = 0;
          this.checkbox = [];
        });
      }else{
        this.tree_http();
      }
      this.$refs.searchKey.blur()
    },
    // 选择订单
    onChoose(item,i){
      if(this.Active != i){
        this.Active  = i
        this.yuyue[0] = item
      }
    },
    // 预约订单
    onClickBack: function () {
        this.$router.push("/yuyuedingdan")
    },
    onClickMore: function () {
      this.popup_left = true;
      this.title_popup();
    },
    delyuyue: function (id) {
      this.$vux.confirm.show({
        title: "是否删除预约",
        onConfirm: () => {
          this.$HTTP
            .HttpPost("/Member/Appointment/delOrder", { id: id })
            .then((data) => {
              if (data.data.code === 200) {
                this.onClickBack();
              }
            });
        },
      });
    },
    tree_http: function (value) {
      if (value !== null) {
        this.page = 1;
        this.last_page = 0;
        this.quantity = 10;
        this.scroller = [];
      }
      if (this.last_page == this.page) {
        this.$HTTP
        .HttpPost("/Member/Appointment/getItemList", {
          sid: this.popup_id,
          classify_id: value,
          page: this.page,
          quantity: this.quantity,
        })
        .then((data) => {
          this.last_page = data.data.data.last_page;
          this.content = data.data.data.data;
          this.scroller = [...this.scroller, ...this.content];
          this.showPrice = this.scroller[0] && this.scroller[0].price;
          this.total = 0;
          this.checkbox = [];
        });
        return;
      }
      this.$HTTP
        .HttpPost("/Member/Appointment/getItemList", {
          sid: this.popup_id,
          classify_id: value,
          page: this.page,
          quantity: this.quantity,
        })
        .then((data) => {
          this.last_page = data.data.data.last_page;
          this.content = data.data.data.data;
          this.scroller = [...this.scroller, ...this.content];
          this.showPrice = this.scroller[0] && this.scroller[0].price;
          this.total = 0;
          this.checkbox = [];
        });
    },
    onScrollBottom: function () {
      if (this.loading === true) {
        return;
      } else {
        this.loading = true;
        setTimeout(() => {
          if (this.page < this.last_page) {
            ++this.page;
            console.log(1);
            this.tree_http(null);
          }
          this.loading = false;
        }, 1000);
      }
    },
    onChange: function (s) {
      let total = 0;
      this.yuyue = [];
      for (let i in s) {
        total += Number(this.content[s[i]].price);
        this.yuyue = [...this.yuyue, this.content[s[i]]];
      }
      this.total = "已选" + this.checkbox.length + "个项目";
      if (this.showPrice) {
        this.total += ",预计金额￥" + total;
      }
    },
    //切换店铺
    title_popup: function (key) {
      if (key === "signOut") {
        this.popup = false;
        return;
      }

      if (key !== undefined) {
        this.title_name = this.popup_content[key].store_name;
        this.popup_id = this.popup_content[key].id;
      }
      this.page = 1
      this.scroller = []
      this.$HTTP
        .HttpPost("/Member/Appointment/getItemList", {
          sid: this.popup_id,
          classify_id: '',
          page: this.page,
          quantity: this.quantity,
        })
        .then((data) => {
          this.last_page = data.data.data.last_page;
          this.content = data.data.data.data;
          this.scroller = [...this.scroller, ...this.content];
          this.showPrice = this.scroller[0] && this.scroller[0].price;
          this.total = 0;
          this.checkbox = [];
        });
      this.popup = false;
    },
    determine: function () {
      console.log(this.popup_id);
      if (this.yuyue.length === 0) {
        return this.$vux.toast.show({
          text: "请选择预约项目",
          type: "text",
          width: "80%",
          isShowMask: true,
        });
      }
      if(this.popup_id == ''){
        return this.$vux.toast.show({
          text: "请选择预约门店",
          type: "text",
          width: "80%",
          isShowMask: true,
        });
      }
      this.$router.push({
        name: "/yuyue",
        params: { yuyue: this.yuyue, sid: this.popup_id },
      });
    },
  },
  created() {
    if (this.$route.params.popup_right !== undefined) {
      this.onClickBack();
    }
  },
  mounted() {
    this.tree_http();
    this.$HTTP
      .HttpPost("/Member/Appointment/getStoreSelect", {})
      .then((data) => {
        this.popup_content = data.data.data;
        // this.popup_id = this.popup_content[0].id
        if(this.popup_content.length == 1){
          this.popup_id = this.popup_content[0].id,
          this.title_name = this.popup_content[0].store_name;
        }
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/zaixianyuyue.vue